/**
 * The numeric scales. Every value is a unitless number: React Native takes
 * density-independent pixels, and react-native-web and MUI take the same numbers
 * as CSS pixels, so a number serves every consumer without conversion.
 *
 * Keys are t-shirt sizes rather than raw values so a component asks for `space.md`
 * and the scale can be retuned without touching it.
 */
/** 4pt grid. `px` exists for hairlines, which are the one legitimate 1pt value. */
export const space = {
    none: 0,
    px: 1,
    xs: 4,
    sm: 8,
    md: 12,
    lg: 16,
    xl: 24,
    '2xl': 32,
    '3xl': 48,
    '4xl': 64,
    '5xl': 96,
};
export const radius = {
    none: 0,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    '2xl': 24,
    /** Pill and circle. Large rather than infinite, which some renderers mishandle. */
    full: 9999,
};
/** Component sizing: control heights, icon boxes, avatars. */
export const size = {
    xs: 16,
    sm: 24,
    md: 32,
    lg: 40,
    xl: 48,
    '2xl': 64,
    /** The minimum touch target both platforms' accessibility guidance asks for. */
    touchTarget: 44,
};
export const borderWidth = {
    none: 0,
    hairline: 1,
    thick: 2,
    heavy: 4,
};
//# sourceMappingURL=scales.js.map